import { v4 as uuidv4 } from "uuid";

// Canonical web-store visitor id. Reads the existing anonymousId first, then the
// legacy stylon_store_visitor fallback, so no visitor loses identity. Creates +
// persists once. Used for page views, campaign clicks, ad clicks, and stamped on
// bookings/orders so ad attribution can join a click to a conversion.
/** The query parameter a hand-off to the real browser carries the in-app visitor key under. */
export const HANDOFF_VISITOR_PARAM = 'stylon_vk';
const VISITOR_KEY_SHAPE = /^[0-9a-zA-Z_-]{16,64}$/;

/**
 * THE PERSON SURVIVES THE JUMP (2026-10-13). The product page inside Instagram's or Facebook's
 * browser hands the shopper to Chrome or Safari, and the real browser has its own localStorage —
 * so for a month every shopper who crossed was two visitors: two keys, two coin-flips for the
 * checkout arm, the Instagram referrer on one and the basket on the other. 11 such pairs in two
 * days, 5 in different arms, two of them the SAME two keys on both days.
 *
 * The hand-off address now carries the in-app key (`stylon_vk`), and this adopts it before the
 * first event of the landing: the browser continues the same person. Only a key of the shape we
 * mint is adopted; anything else is ignored. Called once, at boot, before analytics.
 */
export function adoptHandoffVisitorKey(search) {
  try {
    const q = new URLSearchParams(String(search || ''));
    const carried = q.get(HANDOFF_VISITOR_PARAM);
    if (!carried || !VISITOR_KEY_SHAPE.test(carried)) return null;
    if (localStorage.getItem('anonymousId') !== carried) localStorage.setItem('anonymousId', carried);
    return carried;
  } catch (_e) {
    return null;
  }
}

export function getVisitorKey() {
  try {
    let id =
      localStorage.getItem("anonymousId") ||
      localStorage.getItem("stylon_store_visitor");
    if (!id) {
      id = uuidv4();
    }
    localStorage.setItem("anonymousId", id);
    return id;
  } catch (_e) {
    return uuidv4();
  }
}
